export interface IEnvironmentConfig {
  api: {
    url: string;
  };
  isCheatEnabled?: boolean;
}

export class EnvironmentConfig {
  private static config: IEnvironmentConfig;

  public static init(config: IEnvironmentConfig): void {
    this.config = config;
  }

  public static get url(): string {
    return this.config.api.url;
  }

  public static get isCheatEnabled(): boolean {
    return !!this.config.isCheatEnabled;
  }
}
